import React from 'react'

const MapButtons = ({ editForm, disableButton, setEditForm, onSaveMapDetails, onSiteMapCancel, deleteAllMarkers }) => {
  return (
    <div className='mt-3' style={{ textAlign: "center" }}>
    {
        !editForm &&
        <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => setEditForm(true)} >
            <span className="ViewUpdate">Edit</span>
        </button>
    }
    {
        editForm &&
        <button className="DataAccessEdit" style={{ width: "100px" }} disabled={disableButton} onClick={onSaveMapDetails}>
            <span className="ViewUpdate">Save</span>
        </button>
    }
    {
        editForm &&
        <button className="DataAccessEdit" style={{ width: "100px" }} onClick={onSiteMapCancel} >
            <span className="ViewUpdate">Cancel</span>
        </button>
    }
    {
        !editForm &&
        <button className="DataAccessEdit" style={{ width: "100px" }} onClick={deleteAllMarkers}>
            <span className="ViewUpdate">Delete</span>
        </button>
    }
</div>
  )
}

export default MapButtons